import type { BuilderPick } from "./builderPick";

/**
 * The Towers tab's "upgrade ready" arrow (owner 2026-10-24: "the red dot and ! … I can't find what to press to get rid
 * of them"). It shows while a builder is free and an upgrade is affordable, and stops nagging once the player has looked:
 * opening the Towers page marks that upgrade seen (the page then points at it). A different upgrade becoming ready — the
 * next level after one finishes, another tower once the gold is there — is news again. Seen keys live for the session,
 * not the save: after a relaunch a still-idle builder is worth one more look. Pure, so the rule is tested without a DOM.
 */
export class UpgradeNudge {
  private readonly seen = new Set<string>();

  /** The upgrade the arrow is about (target, index, level), or null when there is nothing to start now. */
  static keyOf(pick: BuilderPick): string | null {
    return pick.kind === "idle" && pick.actionable ? `${pick.option.target}:${pick.option.towerIndex}:${pick.option.level}` : null;
  }

  /** Whether the tab shows the arrow for `pick`: something to start now that the player has not looked at yet. */
  shows(pick: BuilderPick): boolean {
    const key = UpgradeNudge.keyOf(pick);
    return key !== null && !this.seen.has(key);
  }

  /** The player opened the Towers page on `pick`: its upgrade is seen. Returns whether that changed anything. */
  markSeen(pick: BuilderPick): boolean {
    const key = UpgradeNudge.keyOf(pick);
    if (key === null || this.seen.has(key)) return false;
    this.seen.add(key);
    return true;
  }
}

/** The hub's nudge (outlives one HubView: the hub is rebuilt after every battle). */
export const upgradeNudge = new UpgradeNudge();
